import {
  CLEAN_SESSIONS_DETAIL_ORDER_VINCULATION,
  CLEAN_SESSIONS_DETAIL_ORDER_VINCULATION_ERROR,
} from '_models/redux/types';

export const orderVinculationSessionsDetailClean = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_SESSIONS_DETAIL_ORDER_VINCULATION,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_SESSIONS_DETAIL_ORDER_VINCULATION_ERROR,
    });
  }
};
